import { ReversePipe } from './shared/pipes/ReversePipe';
import { HomeModule } from './home/home.module';

import { SidebarModule } from './sidebar/sidebar.module';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule , NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthHomeModule } from './auth-home/auth-home.module';
import { ConfigService } from './shared/services/config.service';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { HttpRequestService } from './shared/services/http-request.service';
import { UserManagerService } from './shared/services/user-manager.service';
import { AutoGeneratedComponent } from './auto-generated/auto-generated.component';

import { AppStorageService } from './shared/services/app-storage.service';
import { MatButtonModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { Globals } from './shared/services/globals';
import { MaterialModule} from './material-module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { MenuModule } from './menu/menu.module';
import { AdminMenuComponent } from './menu/admin-menu/admin-menu.component';
import { RouteReuseStrategy } from '@angular/router';
import { SnakeComponent } from './shared/components/snake/snake.component';

import { ToastrModule } from 'ngx-toastr';
import { DecimalPipe } from '@angular/common';



import { AppTransModule } from './app-trans/app-trans.module';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';

import { LoginFormComponent } from './account/login-form/login-form.component';
import { AboutUsComponent } from './basic-data/about-us/about-us.component';
import { DefaultComponent } from './basic-data/default/default.component';
import { MedicalCenterComponent } from './basic-data/medical-center/medical-center.component';
import { MedicalPlatformComponent } from './basic-data/medical-platform/medical-platform.component';
import { ConsultantComponent } from './basic-data/consultant/consultant.component';
import { TermsAndConditionsComponent } from './basic-data/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './basic-data/privacy-policy/privacy-policy.component';
import { UsageAgreementComponent } from './basic-data/usage-agreement/usage-agreement.component';
import { DoctorsComponent } from './basic-data/doctors/doctors.component';
import { DoctorProfileComponent } from './basic-data/doctor-profile/doctor-profile.component';
import { NewsDetailsComponent } from './basic-data/news-details/news-details.component';
import { JoinUsComponent } from './basic-data/join-us/join-us.component';
import { ResearchComponent } from './basic-data/research/research.component';
import { StatisticsComponent } from './basic-data/statistics/statistics.component';
import { ContactUSComponent } from './basic-data/contact-us/contact-us.component';
import { AwarenessComponent } from './basic-data/awareness/awareness.component';
import { OuterPagesHeaderComponent } from './basic-data/outer-pages-header/outer-pages-header.component';
import { OuterPagesFooterComponent } from './basic-data/outer-pages-footer/outer-pages-footer.component';
import { IntroVideosComponent } from './account/intro-videos/intro-videos.component'

import { RegistrationFormComponent } from './account/registration-form/registration-form.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { ChangePasswordFormComponent } from './account/change-password-form/change-password-form.component';
import { UserPassword } from './shared/models/Validation/UserPassword';
import { EmailExist } from './shared/models/Validation/EmailExist';
import { SendEmailFormComponent } from './account/send-email-form/send-email-form.component';
import { ForgetPasswordFormComponent } from './account/forget-password-form/forget-password-form.component';
import { SendEmailConfirmationComponent } from './account/send-email-confirmation/send-email-confirmation.component';
import { EmailNotExist } from './shared/models/Validation/EmailNotExist';
import { RolePermissionsDirective } from './shared/directive/role-permissions.directive';

import { MatFormFieldModule, MatSelectModule } from '@angular/material';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CarouselModule } from 'ngx-owl-carousel-o';


@NgModule({
  declarations: [
    AppComponent, HeaderComponent, AutoGeneratedComponent , SnakeComponent , ReversePipe  ,
    LoginFormComponent ,RegistrationFormComponent , IntroVideosComponent,
    ChangePasswordFormComponent,UserPassword,SendEmailFormComponent,ForgetPasswordFormComponent,
    SendEmailConfirmationComponent,EmailNotExist,
    AboutUsComponent,DefaultComponent,MedicalCenterComponent,MedicalPlatformComponent,ConsultantComponent,
    TermsAndConditionsComponent,PrivacyPolicyComponent,UsageAgreementComponent,DoctorsComponent,JoinUsComponent,ResearchComponent,StatisticsComponent,ContactUSComponent,
    AwarenessComponent,OuterPagesHeaderComponent,OuterPagesFooterComponent,DoctorProfileComponent,NewsDetailsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AuthHomeModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatRadioModule ,
    MatButtonModule,
    SidebarModule,
    MenuModule,
    HttpClientModule,
    HttpClientJsonpModule,
    HomeModule,
    ToastrModule.forRoot(),
    AppTransModule,
    AuthHomeModule,
    NgbModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatFormFieldModule,
    CarouselModule,
    NgxMatSelectSearchModule

  ],
  entryComponents:  [SnakeComponent] ,
  providers: [{ provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false }},
    ConfigService, HttpRequestService, UserManagerService, AppStorageService, Globals , DecimalPipe

  ],
  exports: [ ],
  schemas: [
      CUSTOM_ELEMENTS_SCHEMA,
      NO_ERRORS_SCHEMA
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
